import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store'

import PageNotFound from '../views/page-not-found.vue'
import Dashboard from '../views/info/dashboard.vue'

const routes = [
  {
    path: '*',
    name: 'Halaman Tidak Ditemukan',
    component: PageNotFound
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(`../views/page-login.vue`)
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  }
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes
})

export default router
